export default __webpack_public_path__ + "images/pages/homepage/at-6d2b7cea0634f758bfd9957d8ceca892.svg";